<template lang="pug">
.box
  img.title.vip-title(src='@/assets/imgs/rights/title.png')
  .compare-btn.color_text_vip_3(@click='checkCompare()') 查看特权对比
  .content-area
    .content(v-for='(item, index) in rightsList' @click="goContent(index, 0)")
      img.icon(:src='item.img')
      .content-title {{item.title}}
      .desc.color_text_vip_3 {{item.desc}}
  img.title(src='@/assets/imgs/rights/title2.png')
  .content-area
    .content(v-for='(item, index) in translateRightsList' @click="goContent(index, 1)")
      img.icon(:src='item.img')
      .content-title {{item.title}}
      .desc.color_text_vip_3 {{item.desc}}
  img.title-mobile(src='@/assets/imgs/rights/title3.png')
  .mobile-content-area
    .mobile-content(v-for='(item, index) in mobileRightsList' @click="goContent(index, 2)")
      img.icon(:src='item.img')
      .mobile-title {{item.title}}
      .mobile-desc.color_text_vip_3 {{item.desc}}
</template>

<script>
export default {
  name: 'vipRights',
  data() {
    return {
      rightsList: [
        {
          title: '文档翻译',
          desc: '100万字符/月',
          img: require('@/assets/imgs/rights/1.png'),
        },
        {
          title: '文档上传',
          desc: '40MB以内',
          img: require('@/assets/imgs/rights/2.png'),
        },
        {
          title: '术语库',
          desc: '10万对',
          img: require('@/assets/imgs/rights/3.png'),
        },
        {
          title: '文档导出',
          desc: '导出word格式',
          img: require('@/assets/imgs/rights/3_1.png'),
        },
        {
          title: 'AIBox',
          desc: '畅享润色改写',
          img: require('@/assets/imgs/rights/3_2.png'),
        },
        {
          title: '文档问答',
          desc: '私人阅读助理',
          img: require('@/assets/imgs/rights/3_3.png'),
        },
        {
          title: '单词图谱',
          desc: '思维导图记忆法',
          img: require('@/assets/imgs/rights/3_4.png'),
        },
        {
          title: '图片翻译',
          desc: '批量10张/次',
          img: require('@/assets/imgs/rights/4.png'),
        },
        {
          title: '英文写作',
          desc: '高级纠错',
          img: require('@/assets/imgs/rights/5.png'),
        },
        {
          title: '音频翻译',
          desc: '30小时/月',
          img: require('@/assets/imgs/rights/11.png'),
        },
        {
          title: '同传翻译',
          desc: '200小时/月',
          img: require('@/assets/imgs/rights/12.png'),
        },
        {
          title: '权威词典',
          desc: '畅享专业查词',
          img: require('@/assets/imgs/rights/6.png'),
        },
        {
          title: '离线词典',
          desc: '断网也能查',
          img: require('@/assets/imgs/rights/7.png'),
        },
        {
          title: '截图翻译',
          desc: '钉至屏幕免费用',
          img: require('@/assets/imgs/rights/8.png'),
        },
        {
          title: '纯净去广告',
          desc: '全平台无广告体验',
          img: require('@/assets/imgs/rights/9.png'),
        },
        {
          title: '会员标识',
          desc: '彰显会员身份',
          img: require('@/assets/imgs/rights/10.png'),
        },
      ],
      translateRightsList: [
        {
          title: '图片翻译',
          desc: '500个',
          img: require('@/assets/imgs/rights/2-1.png'),
        },
        {
          title: '同传翻译',
          desc: '100个',
          img: require('@/assets/imgs/rights/2-2.png'),
        },
        {
          title: '音频翻译',
          desc: '100个',
          img: require('@/assets/imgs/rights/2-3.png'),
        },
      ],
      mobileRightsList: [
        {
          title: '优质外刊',
          desc: '深度解读外刊',
          img: require('@/assets/imgs/rights/3-1.png'),
        },
        {
          title: '原著精读',
          desc: '100本原版书专业解读',
          img: require('@/assets/imgs/rights/3-2.png'),
        },
        {
          title: '简洁首页',
          desc: '自定义背景',
          img: require('@/assets/imgs/rights/3-3.png'),
        },
        {
          title: '发音指导',
          desc: '发音智能指导',
          img: require('@/assets/imgs/rights/3-4.png'),
        },
        {
          title: '网页翻译',
          desc: '轻松浏览外文网页',
          img: require('@/assets/imgs/rights/3-5.png'),
        },
        {
          title: '听力资源',
          desc: '精选优质资料',
          img: require('@/assets/imgs/rights/3-6.png'),
        },
      ],
      type: 0,
    };
  },
  methods: {
    checkCompare() {
      this.$router.push({ path: '/privilege', query: { ...this.$route.query } });
    },
    goContent(idx, type) {
      this.type = type;
      if (this.type === 0) {
        this.$router.push({ path: '/privilege', hash: `#${idx}`, query: { ...this.$route.query } });
      } else if (this.type === 1) {
        this.$router.push({ path: '/privilege', hash: `#${idx + this.rightsList.length}`, query: { ...this.$route.query } });
      } else if (this.type === 2) {
        this.$router.push({ path: '/privilege', hash: `#${idx + this.rightsList.length + this.translateRightsList.length}`, query: { ...this.$route.query } });
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
.box
  width 1201px
  margin 0 auto
  .title
    width auto
    height 36px
    margin 61px auto 20px auto
    padding-left 9px
    display block
  .compare-btn
    width 88px
    height 28px
    border-radius 6px
    border 1px solid #DBB89A
    font-size 12px
    line-height 28px
    text-align center
    margin 0 auto
    cursor pointer
  .content-area
    display flex
    flex-wrap wrap
    margin-top 36px
    justify-content center
    .content
      width 286px
      height 170px
      background url('~@/assets/imgs/content-back.png') 0 0 / 100%
      text-align center
      margin-bottom 20px
      border-radius 16px
      cursor pointer
      &:not(:nth-child(4n))
        margin-right 19px
      &:hover
        box-shadow 0px 6px 30px rgba(18, 25, 43, 0.05)
      .icon
        width 58px
        height 58px
        margin 24px 0 9px
      .content-title
        color #7A5931
        margin-bottom 11px
        font-size 20px
        font-weight 500
      .desc
        font-family 'PingFang SC'
        font-style normal
        font-weight 400
        font-size 16px
        opacity 0.8
  .title-mobile
    width auto
    height 36px
    margin 62px auto 48px
    display block
  .mobile-content-area
    display flex
    margin-bottom 140px
    .mobile-content
      width 300px
      text-align center
      cursor pointer
      .icon
        width 70px
        margin-bottom 24px
      .mobile-title
        color #7A5931
        margin-bottom 12px
        font-size 20px
        font-weight 500
      .mobile-desc
        font-size 16px
        font-family 'PingFang SC'
        opacity 0.8
</style>
